import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import classnames from "classnames";
import { toggleArray } from "~/services/helpers";
import { Form } from "react-bootstrap";
import PopupActions from '../../../Components/PopupActions/PopupActions';
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import { ChevronRight } from "~/Components/Icons/Icons";
import __ from 'lodash';
import { toast } from 'react-toastify';

const AdminCommsManagement = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});
    const [filter, setFilter] = useState('reminder');
    const [meta, setMeta] = useState({});
    const [selected, setSelected] = useState([]);
    const [sentComms, setSentComms] = useState([]);
    const [sentCommsData, setSentCommsData] = useState([]);
    const [searchParams, setSearchParams] = useState({
        name: '',
        email: '',
        invites: '',
        wave: '',
        addon: '',
        senton: '',
        language: '',
        status: '',
        emailType: ''
    });
    const types = {
        invitation: 'Guest invitation',
        accepted: 'RSVP Accepted',
        declined: 'RSVP Declined',
        new_code: 'Code Reminder',
        host: 'Host Invitation',
        pre_event: 'Pre Event',
        event_survey: 'Event Survey',
        reminder: 'Reminder'
    };

    const changeFilter = (filter) => {
        setFilter(filter);
        setSelected([]);
        setSentComms([]);
        setSearchParams({
            name: '',
            email: '',
            invites: '',
            wave: '',
            addon: '',
            senton: '',
            language: '',
            status: '',
            emailType: ''
        });
    };

    const loadMeta = () => {
        adminHttp
            .get(`/events/${event.id}/invitations/meta`)
            .then(res => {
                setMeta(res.data)
            });
    };

    const loadData = (page = 1) => {
        adminHttp
            .get(`/events/${event.id}/invitations?filter=${filter}&page=${page}&name=${searchParams.name}&email=${searchParams.email}&invites=${searchParams.invites}&wave=${searchParams.wave}&addon=${searchParams.addon}&senton=${searchParams.senton}&language=${searchParams.language}&status=${searchParams.status}&emailType=${searchParams.emailType}`)
            .then(res => {
                setResponse(res.data);
            });
    };

    useEffect(loadMeta, [event]);
    useEffect(loadData, [filter, event]);
    useEffect(loadData, [searchParams]);

    const handleSelectedChange = (id, isSentComms, emailType) => {
        if (isSentComms) {
            setSentComms(toggleArray(sentComms, id));
            setSentCommsData(toggleArray(sentCommsData, { id: id, email_type: emailType }));
        } else {
            setSelected(toggleArray(selected, id));
        }
    };

    const sendReminder = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send-reminder`, { 'ids': selected }),
            {
                pending: 'Sending Reminder...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Remind email(s) sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    }

    const sendRegIncomplete = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send-reg-incomplete`, { 'ids': selected, }),
            {
                pending: 'Sending Reg Incomplete...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Reg incomplete email(s) sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
        [{ id: 103, emailType: 'reminder' }]
    }

    const sendPreEvent = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send-pre-event`, { 'ids': selected }),
            {
                pending: 'Sending Pre-event...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Pre-event email(s) sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    const sendSurveys = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send-event-survey`, { 'ids': selected }),
            {
                pending: 'Sending Survey(s)...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Survey(s) sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    const sendSentComms = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send-multi`, { 'ids': sentCommsData }),
            {
                pending: 'Re-Sending Email(s)...',
                success: {
                    render() {
                        setSentComms([]);
                        setSentCommsData([]);
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Email(s) re-sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    // DATA FILTER
    const filterUsers = __.debounce((type, value) => {
        setSearchParams((prev) => (
            {
                ...prev,
                [type]: value
            }
        ))
    }, 500);

    const changeEmailType = (e) => {
        const value = e.target.value;
        setSearchParams((prev) => (
            {
                ...prev,
                emailType: value
            }
        ));
    }

    // SELECT ALL USERS
    const selectAll = () => {

        let selectedIds = [];

        if (response.data && response.data.length > 0 && response.data.length === selected.length) {
            setSelected([]);
        } else {
            response.data.map((item) => {
                selectedIds.push(item.id);
            })
        }

        setSelected(selectedIds);
    }


    // SELECT ALL USERS
    const selectAllSentComms = () => {

        let selectedIds = [];

        if (response.data && response.data.length > 0 && response.data.length === sentComms.length) {
            setSentComms([]);
        } else {
            response.data.map((item) => {
                selectedIds.push(item.email_id);
            })
        }

        setSentComms(selectedIds);
    }

    return (
        <>
            <div className="data-uploads">
                <div className="row">
                    <div className="col-8">
                        <h2>Registration Management</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TopSubmenu>
                            <a href="#" onClick={e => changeFilter('reminder')}
                                className={classnames({ 'active': filter === 'reminder' })}>Reminder ({meta.reminder})</a>

                            <a href="#" onClick={e => changeFilter('reg_incomplete')}
                                className={classnames({ 'active': filter === 'reg_incomplete' })}>Reg Incomplete ({meta.reg_incomplete})</a>

                            {/* <a href="#" onClick={e => changeFilter('incomplete_sent')}
                                className={classnames({'active' : filter === 'incomplete_sent'})}>Incomplete Sent ({meta.incomplete_sent})</a> */}

                            <a href="#" onClick={e => changeFilter('pre_event')}
                                className={classnames({ 'active': filter === 'pre_event' })}>Pre-Event ({meta.pre_event})</a>

                            {/* <a href="#" onClick={e => changeFilter('pre_event_sent')}
                                className={classnames({'active' : filter === 'pre_event_sent'})}>Pre-Event Email Sent ({meta.pre_event_sent})</a> */}

                            <a href="#" onClick={e => changeFilter('pre_event_sent')}
                                className={classnames({ 'active': filter === 'pre_event_sent' })}>Survey ({meta.pre_event_sent})</a>

                            {/* <a href="#" onClick={e => changeFilter('post_event_survey_sent')}
                                className={classnames({'active' : filter === 'post_event_survey_sent'})}>Post-Event Survey Sent ({meta.post_event_survey_sent})</a> */}


                            <a href="#" onClick={e => changeFilter('sent_comms')}
                                className={classnames({ 'active': filter === 'sent_comms' })}>Sent Comms ({meta.sent_comms})</a>
                        </TopSubmenu>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <div className="table-scrollable">
                                    {['sent_comms'].includes(filter) &&
                                        <select
                                            name="emailType"
                                            className="form-control mb-2 w-25"
                                            value={searchParams.emailType}
                                            onChange={changeEmailType}
                                        >
                                            <option value="">All</option>
                                            <option value="reminder">Reminder</option>
                                            <option value="reg-incomplete">Reg incomplete</option>
                                            <option value="pre-event">Pre-event</option>
                                            <option value="survey-emails">Survey emails</option>
                                        </select>
                                    }
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                {['pre_event', 'pre_event_sent', 'pre_event_sent', 'post_event_survey_sent', 'sent_comms', 'reminder', 'reg_incomplete'].indexOf(filter) > -1
                                                    && <th scope="row">
                                                        <Form.Check
                                                            inline
                                                            type="checkbox"
                                                            checked={
                                                                filter === 'sent_comms'
                                                                    ? response.data && response.data.length > 0 && response.data.length === sentComms.length
                                                                    : response.data && response.data.length > 0 && response.data.length === selected.length}
                                                            onClick={() => {
                                                                if (filter === 'sent_comms') {
                                                                    selectAllSentComms();
                                                                } else {
                                                                    selectAll()
                                                                }
                                                            }}
                                                        />
                                                    </th>
                                                }
                                                {['sent_comms'].includes(filter) && <th scope="col">Email Type</th>}
                                                <th scope="col">Guest Name</th>
                                                <th scope="col">Guest Email</th>
                                                <th scope="col">Invitees</th>
                                                <th scope="col">Wave/Package</th>

                                                {['pre_event_sent', 'post_event_survey_sent'].includes(filter) && <th scope="col">Sent ON</th>}

                                                <th scope="col">Language</th>

                                                <th scope="col">Reg Status</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                {['pre_event', 'pre_event_sent', 'pre_event_sent', 'post_event_survey_sent', 'sent_comms', 'reminder', 'reg_incomplete'].indexOf(filter) > -1 && <td></td>}
                                                {filter === 'sent_comms' && <td></td>}
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Name"
                                                        onChange={(searchValue) => filterUsers('name', searchValue.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Email"
                                                        onChange={(searchValue) => filterUsers('email', searchValue.target.value)}
                                                    />
                                                </td>
                                                {filter !== 'declined' && <td></td>}
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Wave"
                                                        onChange={(searchValue) => filterUsers('wave', searchValue.target.value)}
                                                    />
                                                </td>
                                                {filter === 'pending' && <td></td>}
                                                {filter === 'reminder' && <td></td>}
                                                {filter !== 'declined' && <td></td>}
                                                {filter === 'sent_comms' && <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Status"
                                                        onChange={(searchValue) => filterUsers('status', searchValue.target.value)}
                                                    />
                                                </td>}
                                                <td>
                                                </td>
                                            </tr>
                                            {response.data?.map((invitation, index) => (
                                                <tr key={index} >

                                                    {['pre_event', 'pre_event_sent', 'pre_event_sent', 'post_event_survey_sent', 'sent_comms', 'reminder', 'reg_incomplete'].indexOf(filter) > -1 && (
                                                        <td>
                                                            <Form.Check
                                                                key={filter === 'sent_comms' ? invitation.email_id : invitation.id}
                                                                inline
                                                                type="checkbox"
                                                                id={filter === 'sent_comms' ? `upload-${invitation.email_id}` : `upload-${invitation.id}`}
                                                                value={filter === 'sent_comms' ? invitation.email_id : invitation.id}
                                                                onChange={e => {
                                                                    if (filter === 'sent_comms') {
                                                                        handleSelectedChange(invitation.email_id, true, invitation.email_type)
                                                                    } else {
                                                                        handleSelectedChange(invitation.id)
                                                                    }
                                                                }}
                                                                checked={filter === 'sent_comms' ? sentComms.indexOf(invitation.email_id) >= 0 : selected.indexOf(invitation.id) >= 0}
                                                            />
                                                        </td>
                                                    )}

                                                    {filter === 'sent_comms' &&
                                                        <td>
                                                            {types[invitation.email_type]}
                                                        </td>
                                                    }

                                                    <td>{invitation.main_guest?.full_name || invitation.user.full_name}</td>
                                                    <td>{invitation.main_guest?.email || invitation.user.email}</td>
                                                    <td>{invitation.guest_allowance}</td>
                                                    <td>
                                                        {invitation?.wave?.name || '-'}
                                                        {" / "}
                                                        {invitation?.package?.name || '-'}
                                                    </td>

                                                    {filter === 'pre_event_sent' && <td><Moment format="DD/MM/YYYY h:mm:ss a" date={invitation.pre_event_sent_at} /></td>}
                                                    {filter === 'post_event_survey_sent' && <td><Moment format="DD/MM/YYYY h:mm:ss a" date={invitation.survey_sent_at} /></td>}

                                                    <td>{invitation.user?.language?.name || '-'}</td>
                                                    <td>{invitation.registration_status}</td>
                                                    <td>
                                                        <Link to={`/guests/registration/${invitation.id}`}>
                                                            <ChevronRight />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {response.per_page < response.total && (
                                    <Pagination
                                        activePage={response.current_page}
                                        itemsCountPerPage={response.per_page}
                                        totalItemsCount={response.total}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={(page) => {
                                            setSentComms([]);
                                            setSelected([]);
                                            loadData(page);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selected.length > 0 && (
                <PopupActions>

                    {/* Send Reg Incomplete */}
                    {filter === 'reg_incomplete' && (
                        <ConfirmedButton
                            confirmTitle={"Send Reg Incomplete"}
                            confirmText={`You are about to send an registration incomplete email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendRegIncomplete}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Reg Incomplete ({selected.length})
                        </ConfirmedButton>
                    )}

                    {/* Send Reminder Email */}
                    {filter === 'reminder' && (
                        <ConfirmedButton
                            confirmTitle={"Send Reminder Email"}
                            confirmText={`You are about to send an reminder email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendReminder}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Reminder Email ({selected.length})
                        </ConfirmedButton>
                    )}

                    {/* Pre-Event Email Unsent */}
                    {filter === 'pre_event' && (
                        <ConfirmedButton
                            confirmTitle={"Send Pre-Event Email"}
                            confirmText={`You are about to send an pre-event email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendPreEvent}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Pre Event Email ({selected.length})
                        </ConfirmedButton>
                    )}

                    {/* Pre-Event Email Sent */}
                    {['pre_event_sent'].indexOf(filter) > -1 && (<>
                        <ConfirmedButton
                            confirmTitle={"Re-Send Pre-Event Email"}
                            confirmText={`You are about to re-send an pre-event email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendPreEvent}
                            className="btn btn-secondary btn-xs mr-3">
                            Re-Send Pre Event Email ({selected.length})
                        </ConfirmedButton>
                    </>)}

                    {/* Post-Event Survey Unsent */}
                    {filter === 'pre_event_sent' && (<>
                        <ConfirmedButton
                            confirmTitle={"Send Survey"}
                            confirmText={`You are about to re-send an survey email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendSurveys}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Survey ({selected.length})
                        </ConfirmedButton>
                    </>)}

                    {/* Post-Event Survey Sent */}
                    {['post_event_survey_sent'].indexOf(filter) > -1 && (
                        <ConfirmedButton
                            confirmTitle={"Re-Send Survey"}
                            confirmText={`You are about to re-send an survey email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendSurveys}
                            className="btn btn-secondary btn-xs mr-3">
                            Re-Send Survey ({selected.length})
                        </ConfirmedButton>
                    )}

                </PopupActions>
            )}

            {sentComms.length > 0 && (
                <PopupActions>

                    {/* Sent Comms Sent */}
                    {['sent_comms'].indexOf(filter) > -1 && (
                        <ConfirmedButton
                            confirmTitle={"Re-Send"}
                            confirmText={`You are about to re-send an email to the ${event.name} to ${sentComms.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendSentComms}
                            className="btn btn-secondary btn-xs mr-3">
                            Re-Send ({sentComms.length})
                        </ConfirmedButton>
                    )}
                </PopupActions>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminCommsManagement);
